/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S14_HeadingInputs */

const tr_iade_iptal_s14_heading = /** @type {(inputs: Iade_Iptal_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Değişiklikler`)
};

const en_iade_iptal_s14_heading = /** @type {(inputs: Iade_Iptal_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Amendments`)
};

const de_iade_iptal_s14_heading = /** @type {(inputs: Iade_Iptal_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Änderungen`)
};

const ru_iade_iptal_s14_heading = /** @type {(inputs: Iade_Iptal_S14_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14. Изменения`)
};

/**
* | output |
* | --- |
* | "14. Amendments" |
*
* @param {Iade_Iptal_S14_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s14_heading = /** @type {((inputs?: Iade_Iptal_S14_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S14_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s14_heading(inputs)
	if (locale === "de") return de_iade_iptal_s14_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s14_heading(inputs)
	return tr_iade_iptal_s14_heading(inputs)
});